import { db } from "@/libs/firebase";
import {
	type FirestoreDataConverter,
	type QueryDocumentSnapshot,
	type SnapshotOptions,
	doc,
} from "firebase/firestore";
import { useDocumentData } from "react-firebase-hooks/firestore";

type User = {
	id: string;
	mode: 0 | 1; // 0: 生理管理 or 妊活モード, 1: ピルモード
};

const converter: FirestoreDataConverter<User> = {
	toFirestore(data) {
		return { mode: data.mode };
	},
	fromFirestore(
		snapshot: QueryDocumentSnapshot<{ mode: User["mode"] }>,
		options: SnapshotOptions,
	) {
		return {
			id: snapshot.id,
			mode: snapshot.get("mode"),
		};
	},
};

export const useUser = (userId?: string) => {
	const [value, loading, error] = useDocumentData(
		doc(db, `users/${userId}`).withConverter(converter),
	);

	return {
		user: value,
		loading,
		error,
	};
};
